"use client";

/**
 * Browser-side Meta Pixel helpers. The base Pixel (init + PageView) is loaded by
 * shared/components/providers/MetaPixel.tsx.
 *
 * CompleteRegistration MUST be fired with the server-minted `eventID` so Meta
 * deduplicates it against the Conversions API event that carries the same id.
 * Never generate an id here — always pass the one the server returned.
 */

type Fbq = (
  method: "track" | "trackCustom" | "init",
  event: string,
  params?: Record<string, unknown>,
  options?: { eventID?: string }
) => void;

function getFbq(): Fbq | null {
  if (typeof window === "undefined") return null;
  const fbq = (window as unknown as { fbq?: Fbq }).fbq;
  return typeof fbq === "function" ? fbq : null;
}

/** Fire CompleteRegistration with the shared server event id for CAPI dedup. */
export function trackCompleteRegistration(eventId: string): void {
  if (!eventId) return;
  const fbq = getFbq();
  if (!fbq) return;
  fbq("track", "CompleteRegistration", {}, { eventID: eventId });
}
